import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ffcae1f6558f0014d38574/voltvision18/src/app/rate-card/page.tsx");
